import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Stage environment (`admin.stage.wisesys.info`)
 */
export const stageServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.stage.wisesys.info',
    auroraApiServer: 'https://stage.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://zl45ifbuj0.execute-api.us-east-1.amazonaws.com/stage',
    equipment: 'https://services-stage.us.wisesys.info',
    socketServer: 'wss://stage.socket.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket-stage.us.wisesys.info',
    environment: ServerEnvironment.STAGE,
    auroraServer: 'https://stage-api.aurora-v2.wisesys.info',
    CIEnv: ServerCIEnvironment.STAGE,
    vehicleProfile:
        'https://idlnziuvpk.execute-api.us-east-1.amazonaws.com/stage',
    routePathGeometryServer:
        'https://1k04l2v0j8.execute-api.us-east-1.amazonaws.com/stage',
    configurableWorkflowServer:
        'https://4wsqcxtrih.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://tsh2txeqa4.execute-api.us-east-1.amazonaws.com/stage',
    bannerService:
        'https://1xndpawnvf.execute-api.us-east-1.amazonaws.com/stage'
};
